import { render, staticRenderFns } from "./equipment_add_b.vue?vue&type=template&id=b95bb166&"
import script from "./equipment_add_b.vue?vue&type=script&lang=js&"
export * from "./equipment_add_b.vue?vue&type=script&lang=js&"
import style0 from "./equipment_add_b.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports